module.exports = __webpack_public_path__ + "static/media/logo-negative.bc78b6aa.svg";